import { Link } from "@tanstack/react-router";
import { DEFAULT_CATALOG_SEARCH } from "../lib/types";
import { AccountSlot } from "./AccountSlot";

// The site header, identical structure on every page so nothing shifts when
// navigating: wordmark left, tagline (catalog only) in the middle, then a fixed
// right-hand group of About link, account slot, and — off the catalog — a back
// link. The home links reset to the default catalog view (cleared filters).
export function Masthead({ variant }: { variant: "catalog" | "player" | "about" }) {
  const isCatalog = variant === "catalog";
  const wordmark = (
    <Link className="wordmark" to="/" search={DEFAULT_CATALOG_SEARCH}>
      <span className="wordmark-re">re</span>
      <span>Arcade</span>
    </Link>
  );
  return (
    <header className="masthead">
      <div className="mast-top">
        {isCatalog ? (
          <h1 className="brand">{wordmark}</h1>
        ) : (
          <div className="brand">{wordmark}</div>
        )}
        {isCatalog && (
          <p className="tagline">
            Original Flash and Java games from 1999–2013, back in your browser.
          </p>
        )}
        <div className="mast-right">
          {!isCatalog && (
            <Link className="back" to="/" search={DEFAULT_CATALOG_SEARCH}>
              <span aria-hidden="true">←</span> Back to the catalog
            </Link>
          )}
          {variant !== "about" && (
            <Link className="mast-about" to="/about">
              About
            </Link>
          )}
          <div className="acct-slot">
            <AccountSlot />
          </div>
        </div>
      </div>
    </header>
  );
}
